var SaveDesign = {
    postSaveDesign: function(data, successHandler, errorHandler) {
        var _url = window.ub.config.api_host + '/api/saved_design'

        if (ub.data.updateSaveDesignFromCustomArtworkRequest) {
            _url = window.ub.config.api_host + '/api/saved_design/update';
        }

        // Skip notification when coming from local
        if (ub.config.app_env === 'local') {
            data.test_data = '1';
        }
        
        if (typeof $.ajaxSettings.headers !== "undefined") {
            delete $.ajaxSettings.headers["X-CSRF-TOKEN"];
        }

        const options = {
            method: 'POST',
            url: _url,
            data: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'accessToken': null,
                'Content-Type': 'application/json; charset=utf-8',
                'Access-Control-Allow-Credentials': true,
                'X-Requested-With': 'XMLHttpRequest' 
            },
        }

        axios.request(options)
        .then(function (response) {
                if (response.data.success) {
                    successHandler(response);
                } else {
                    errorHandler(response)
                }
        })
        .catch(function (error) {
            errorHandler(error)
        });
    },

    updateSavedDesignBuilderCustomization: function(successHandler, errorHandler) {
        var _url = ub.config.api_host + '/api/saved_design/update';

        if (typeof $.ajaxSettings.headers !== "undefined") {
            delete $.ajaxSettings.headers["X-CSRF-TOKEN"];
        }

        var designPayload = SaveDesign.prepareSaveDesignPayload();

        var _data = {
            id: ub.current_material.settings.savedDesignID,
            user_id: ub.user.id,
            name: "Prolook Saved Design - order editor",
            material_id: designPayload.material_id,
            builder_customizations: designPayload.builder_customizations,
            sport: designPayload.sport,
            front_thumbnail: designPayload.front_thumbnail,
            back_thumbnail: designPayload.back_thumbnail,
            left_thumbnail: designPayload.left_thumbnail,
            right_thumbnail: designPayload.right_thumbnail,
            top_thumbnail: designPayload.top_thumbnail,
            notes: "Prolook Saved Design - order editor"
        };

        // Skip notification when coming from local
        if (ub.config.app_env === 'local') {
            _data.test_data = '1';
        }

        $.ajax({
            url: _url,
            dataType: "json",
            type: "POST",
            data: JSON.stringify(_data),
            crossDomain: true,
            contentType: 'application/json',
            headers: {"accessToken": null},
        
            success: successHandler,
            error: errorHandler
        });
    },

    prepareSaveDesignPayload: function() {
        ProlookSaveDesign.utilities.getPriceItemCode();
        ProlookSaveDesign.utilities.sortedModifierLabels();
        ProlookSaveDesign.utilities.setMaterialInfo();

        var material = ub.current_material.material;
        var _userID = ub.user.id;
        var _materialID = ub.current_material.material.id;
        var _builderCustomizations = ub.current_material.settings;
        var _sport = ub.current_material.material.uniform_category;
        var _frontView = _builderCustomizations.thumbnails.front_view;
        var _backView = _builderCustomizations.thumbnails.back_view;
        var _leftView = _builderCustomizations.thumbnails.left_view;
        var _rightView = _builderCustomizations.thumbnails.right_view;
        var _topView = _builderCustomizations.thumbnails.top_view;
        var _designName = "Prolook Saved Design - order editor";
        var _notes = "Prolook Saved Design - order editor";

        _builderCustomizations.item_id = material.item_id;

        SaveDesign.prepareOrderData();

        var _data = {
            user_id: ub.user.id,
            name: _designName,
            material_id: _materialID,
            material_name: ub.current_material.material.name,
            user: ub.user.fullname,
            builder_customizations: _builderCustomizations,
            sport: _sport,
            front_thumbnail: _frontView,
            back_thumbnail: _backView,
            left_thumbnail: _leftView,
            right_thumbnail: _rightView,
            top_thumbnail: _topView,
            notes: _notes,
            brand_id: ub.config.brand_id
        };

        return _data;
    },

    prepareOrderData: function() {
        ub.current_material.settings.orderInfo = {
            brand: ub.current_material.material.brand,
            item_id: ub.current_material.material.item_id,
            type: ub.current_material.material.type,
            description: ub.current_material.material.name,
            design_sheet: ub.current_material.settings.pdfOrderForm,
            sku: ub.current_material.material.sku,
            material_id: ub.current_material.material.id,
            url: ub.config.host + window.document.location.pathname,
            price: ub.funcs.getPrice(ub.current_material.material),
            applicationType: ub.config.uniform_application_type.toTitleCase(),
            application_type: ub.config.uniform_application_type,
            additional_attachments: ub.data.orderAttachment,
            notes: ""
        }
    },
}